<template>
	<v-toolbar app height="40" color="white">
		<v-container fluid py-0>
			<v-layout row justify-space-between align-center>
				<v-flex xs5 md3>
					<router-link to="/" class="flex-item">
						<v-icon
							color="primary"
							medium
						>
							home
						</v-icon>
					</router-link>
				</v-flex>
				<v-flex xs7 md3 text-xs-right>
					<div class="flex-item justify-end align-center">
						<label class="profile-name">{{ userName }}</label>
						<v-btn
							flat icon
							class="notification-btn"
							color="primary"
							@click="openNotifications"
						>
							<span class="notification-quantity">
								{{ quantityNotifications }}
							</span>
							<v-icon>notification_important</v-icon>
						</v-btn>
						<div class="profile-image-container">
							<v-icon @click="logout" color="primary">
								person
							</v-icon>
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</v-toolbar>
</template>

<script>

function openNotifications() {
	this.$emit('open-notifications-event');
}

function profileImage() {
	return this.$store.getters.profileImage;
}

async function logout() {
	await this.$http.post('logout', {
		headers: {
			authorization: `Bearer ${this.token}`,
		},
	});
	window.localStorage.clear();
	this.$store.dispatch('clearUser');
	this.$router.push({ name: 'login' });
}

function companyLogo() {
	return this.getImageUrl(this.$store.getters.companyLogo);
}

function userName() {
	return this.$store.getters.userName;
}

export default {
	name: 'app-header',
	computed: {
		companyLogo,
		profileImage,
		userName,
	},
	methods: {
		logout,
		openNotifications,
	},
	props: {
		quantityNotifications: {
			default: 0,
			type: Number,
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	@media (max-width: 599px) {
		margin-left: 0px !important;
		margin-right: 0px !important;
	}
}

.toolbar {
	background-color: map-get($colors, white);
	box-shadow: none;
}

.flex-item {
	display: flex;
}

.profile {
	&-name {
		color: map-get($colors, black);
		font-family: map-get($fonts, open-bold);
		font-size: 13px;
		font-weight: bold;
		padding-right: 9px;
		vertical-align: super;
	}

	&-image-container {
		align-items: center;
		background-color: white;
		border: 1px solid map-get($colors, base);
		border-radius: 100%;
		display: inline-flex;
		height: 30px;
		justify-content: center;
		width: 30px;
	}
}

.notification {
	&-btn {
		background-color: transparent !important;
		border-radius: 0px;
		box-shadow: none;
		height: auto;
		margin: 0px 25px 0px 0px;
		min-width: auto;
		width: auto;
	}

	&-quantity {
		background-color: map-get($colors, border);
		border-radius: 100%;
		color: white;
		font-family: map-get($fonts, lato-regular);
		font-size: map-get($sizes, small10);
		height: 12px;
		right: 0px;
		line-height: 10px;
		position: absolute;
		text-align: center;
		top: 0px;
		width: 12px;
		z-index: 2;
	}
}

.btn-notification {
	color: map-get($colors, base);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-header.vue